import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
export const ACTION = {
  LIST: 'LIST_COMPONENT_OPAQUE',
  GET: 'GET_COMPONENT_OPAQUE',
  CREATE: 'CREATE_COMPONENT_OPAQUE',
  EDIT: 'EDIT_COMPONENT_OPAQUE',
  DELETE: 'DELETE_COMPONENT_OPAQUE',
  DUPLICATE: 'DUPLICATE_COMPONENT_OPAQUE',
  CLEAR_ERROR: 'CLEAR_ERROR_COMPONENT_OPAQUE',
};

export const listComponentOpaque = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_COMPONENT_OPAQUE,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
      },
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const getComponentOpaque = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_COMPONENT_OPAQUE}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createComponentOpaque = (name, solarAbsorptanceId, heatDissipationId, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('solar_absorptance_id', solarAbsorptanceId);
  formData.set('heat_dissipation_id', heatDissipationId);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `oq_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_COMPONENT_OPAQUE,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createComponentWithMaterials = (name, solarAbsorptanceId, heatDissipationId, description, image, cfpValue, cfpUnit, material_list)=>{
  const formData = new FormData();
  formData.set('name',name);
  formData.set('solar_absorptance_id',solarAbsorptanceId);
  formData.set('heat_dissipation_id',heatDissipationId);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `oq_${new Date().valueOf()}`);
  formData.set('material_list', JSON.stringify(material_list))
  return{
    type: ACTION.CREATE,
    payload : RestClient.request({
      method: 'post',
      url: Constants.API_COMPONENT_OPAQUE,
      data: formData,
    }).catch(err => Promise.reject(err.response.data))
  }
}

export const deleteComponentOpaque = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_COMPONENT_OPAQUE}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateComponentOpaque = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_COMPONENT_OPAQUE}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editMaterialComponent = (id, name, solarAbsorptanceId, heatDissipationId, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (solarAbsorptanceId) formData.set('solar_absorptance_id', solarAbsorptanceId);
  if (heatDissipationId) formData.set('heat_dissipation_id', heatDissipationId);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `oq_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_COMPONENT_OPAQUE}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorComponentOpaque = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/component_opaque/component_actions.js